import { alpha } from '@mui/material/styles';
export default function Tabs(theme) {
    return {
        MuiTab: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(1.5, 1),
                    textTransform: 'none',
                    '&.Mui-selected': {
                        color: theme.palette.text.primary,
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                        ...theme.applyStyles('dark', {
                            backgroundColor: alpha(theme.palette.primary.main, 0.3)
                        })
                    }
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    variants: [
                        {
                            props: {
                                'data-gef-variant': 'filled'
                            },
                            style: {
                                '& .MuiTabs-indicator': {
                                    display: 'none'
                                },
                                '.MuiTabs-flexContainer': {
                                    alignItems: 'flex-end',
                                    gap: theme.spacing(0.5)
                                },
                                '.MuiTab-root': {
                                    backgroundColor: theme.palette.background[300],
                                    color: theme.palette.text.secondary,
                                    borderTopLeftRadius: theme.radius(2),
                                    borderTopRightRadius: theme.radius(2),
                                    '&.MuiButtonBase-root': {
                                        padding: `0 ${theme.spacing(6)}`
                                    },
                                    height: theme.spacing(6),
                                    '&.Mui-selected': {
                                        zIndex: 1,
                                        backgroundColor: theme.palette.background.paper,
                                        height: theme.spacing(7),
                                        '&.MuiButtonBase-root': {
                                            color: theme.palette.text.primary
                                        },
                                        position: 'relative',
                                        overflow: 'visible',
                                        '&:after': {
                                            content: '""',
                                            width: theme.spacing(2),
                                            height: theme.spacing(2),
                                            position: 'absolute',
                                            bottom: '0px',
                                            left: '100%',
                                            backgroundColor: theme.palette.background.paper,
                                            maskImage: 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><path d="M 0 0 Q 0 16 16 16 L 0 16 Z" /></svg>\')'
                                        },
                                        '&:before': {
                                            content: '""',
                                            width: theme.spacing(2),
                                            height: theme.spacing(2),
                                            position: 'absolute',
                                            bottom: '0px',
                                            right: '100%',
                                            backgroundColor: theme.palette.background.paper,
                                            maskImage: 'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><path d="M 0 16 Q 16 16 16 0 L 16 16 Z" /></svg>\')'
                                        }
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        }
    };
}
